module.exports = __webpack_public_path__ + "img/FondoNegro1.047035e5.jpg";